import {IActionBase} from "./IActionBase";
import {Component} from "react";
import {ActionsManager} from "./actionsManager";
import {dataUtils} from "../js/dataUtils";
import {store} from "../../redux/storeConfig/store";
import {sendApplyooComponentsNotification} from "../infrastructure/useApplyooComponent";


export class action_AP_ShowModal extends Component implements IActionBase {

    actionCode = "action_AP_ShowModal";
    actionName = "action_AP_ShowModal";



    Execute = (prmActionParameters:any,prmActionsManager:ActionsManager, prmElementObj?:any)=> {

        if (!!prmActionParameters.ContainerClientID) {
            let currModalElement = dataUtils.getElementByClientID(prmActionParameters.ContainerClientID);

            if (!!currModalElement) {
                sendApplyooComponentsNotification(currModalElement.ElementGuid, "",{ command: "ShowModal"})
                // store.dispatch({type: 'OPEN_MODEL',
                //     lstModals:{ModalElementGuid:currModalElement.ElementGuid,open:true}});
            }
        }
    }

}